export { default as Lazy } from './Lazy';
